<template>
    <div class="card h-100 border rounded-6 shadow-lg border-warning">
        <div class="card-header rounded-top-6 bg-warning text-white">
            <h5 class="card-title">
                {{ subscription.title }}
            </h5>
        </div>
        <div class="card-body">
            <p class="card-text" v-html="subscription.description"></p>
            <div class="d-flex justify-content-between align-items-center fw-bold my-3">
                <span><a :href="subscription.buyUrl" class="btn btn-primary rounded rounded-pill">Bestellen</a></span>
                <div>
                    <span style="font-size:1.2em">€ {{ subscription.monthlyPriceInEuro.toFixed(2) }}</span>
                    <br/>
                    <span>per maand</span>
                </div>
            </div>
            <hr />
            <div>
                <crypto-euro-price></crypto-euro-price>
            </div>
        </div>
        <img class="card-img-bottom rounded-bottom-6" :src="'/images/' + subscription.imageFileName" :alt="subscription.title" />
    </div>
</template>

<script>
    import CryptoEuroPrice from './CryptoEuroPrice.vue';

    export default {
        name: "SubscriptionCard",
        components: {
            CryptoEuroPrice
        },
        props: {
            subscription: Object,
            periodInDays: Number,
            btcToEurRate: Number, 
            costPerPerWattPerDay: Number,
            bitcoinPayoutPerTeraHashPerDay: Number
        }
    };
</script>
